module.exports = __webpack_public_path__ + "static/media/paff-theme.498bb198.wav";